// React Router 6 warns in the console (production too) about every v7 behaviour
// left unset. Keep today's behaviour, explicitly, until the move to v7.
export const ROUTER_FUTURE = { v7_startTransition: false, v7_relativeSplatPath: false };
